module.exports = __webpack_public_path__ + "img/jambyl2.5b828d11.jpg";